/** Type du facteur */
enum FactorCalendarTypeEnum {
    Semester = 'semester',
    Month = 'month',
    Week = 'week',
    Day = 'day'
}
export default FactorCalendarTypeEnum;